import styled from 'styled-components';

import { Icon } from '../icon';

export const StepList = styled.ol((props) => ({
  [`@media${props.theme.devices.laptop}`]: {
    display: 'flex',
    marginLeft: '8px',
  },
}));

export const Item = styled.li((props) => ({
  alignItems: 'center',
  display: 'flex',
  marginBottom: '24px',

  [`@media${props.theme.devices.laptop}`]: {
    marginBottom: '0',
    marginRight: '0.8rem',
  },
}));

function mobileActive(props) {
  return (!props.active && props.step > 0) || (!props.step && props.completed);
}

const getColor = (props) => {
  if (props.active) {
    return props.theme.newPalette.background.purple;
  }
  
  return props.theme.newPalette.background.gray[100];
};

export const StepText = styled.span((props) => ({
  color: getColor(props),
  fontSize: '16px',
  fontWeight: props.active || props.completed ? 'bold' : 'normal',

  [`@media${props.theme.devices.laptop}`]: {
    display: mobileActive(props) ? 'none' : 'inline',
    fontSize: '14px',
  },
}));

const getStepNumberBackgroundColor = ({
  theme, active, completed, disabled,
}) => {
  if (completed) return theme.colors.status.success;
  if (!disabled && active) return theme.newPalette.background.purple;
  if (active) return theme.newPalette.background.purple;
  return theme.newPalette.background.gray[100]
};

export const StepNumber = styled(StepText)((props) => ({
  alignItems: 'center',
  backgroundColor: getStepNumberBackgroundColor(props),
  borderRadius: '50%',
  color: props.theme.colors.text.white,
  display: 'flex',
  fontSize: '14px',
  fontWeight: 'bold',
  height: '24px',
  justifyContent: 'center',
  marginRight: '7px',
  textAlign: 'center',
  width: '24px',

  [`@media${props.theme.devices.laptop}`]: {
    marginRight: mobileActive(props) ? '0' : '7px',
  },
}));

export const StepIcon = styled(Icon)((props) => ({
  marginLeft: props.completed ? '-2px' : '0',
}));

export const StepContentWrapper = styled.section((props) => ({
  height: '100%',
  overflowX: 'hidden',
  overflowY: 'auto',

  [`@media${props.theme.devices.laptop}`]: {
    padding: '40px 16px',
  },
}));
